import React from 'react'
import { SvgIconProps } from '../Icon.types'

export const Send: React.FC<SvgIconProps> = ({
  width = 24,
  height = 24,
  fill = 'currentColor',
  title = '',
  className,
  ...props
}) => {
  return (
    <svg
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      aria-hidden={!title}
      focusable='false'
      width={width}
      height={height}
      {...props}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M12.0073 4.13725C5.43112 6.40989 0.044556 8.27541 0.03714 8.28282C0.029724 8.29024 1.36813 9.67235 3.01139 11.3541L5.99915 14.412L6.00556 19.0773L6.01194 23.7426L8.47736 21.5193C9.83336 20.2965 10.9511 19.296 10.9613 19.296C10.9715 19.296 12.0405 20.3566 13.3369 21.653C14.6333 22.9493 15.6984 24.005 15.7038 23.999C15.7092 23.993 17.5719 18.6096 19.8432 12.036C22.1145 5.46241 23.98 0.0651256 23.9889 0.0420136C23.9978 0.0189256 23.9958 0.00116557 23.9845 0.00258157C23.9732 0.00399757 18.5835 1.8646 12.0073 4.13725ZM12.2205 6.18904C7.53035 7.80957 3.69095 9.14272 3.68845 9.1516C3.68452 9.16568 6.53291 12.0952 6.97933 12.5362L7.14553 12.7004L11.2887 9.9382C13.5674 8.419 15.4372 7.17601 15.4437 7.17601C15.4503 7.17601 15.7041 7.54857 16.0079 8.00392L16.5602 8.8318L12.276 11.6879L7.99194 14.5441V16.8982V19.2523L8.16594 19.0964C8.26165 19.0106 8.94474 18.3946 9.68394 17.7276L11.0279 16.5148L12.9387 18.4242L14.8496 20.3335L14.8859 20.2288C16.1101 16.7 20.7585 3.23949 20.7524 3.24131C20.7499 3.24203 16.9106 4.56851 12.2205 6.18904Z'
        fill={fill}
      />
    </svg>
  )
}

export default Send
